import React, { useState } from 'react';
import styles from '../../../HoldingsTable/HoldingsTable.module.scss';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import DocumentsTableToggler from './DocumentsTableToggler/DocumentsTableToggler';
import DocumentsTableHead from './DocumentsTableHead/DocumentsTableHead';
import DocumentsTableBody from './DocumentsTableBody/DocumentsTableBody';
import { useMediaQuery, useTheme } from '@material-ui/core';
import {
  DOCUMENTS_TABLE_HEADER,
  DOCUMENTS_TABLE_HEADER_IN_MOBILE,
} from './DocumentsTableHead/tableHeaders';
import DocumentDialog from './DocumentDialog/DocumentDialog';
import { useDialogControl } from '../../../../hooks/useDialogControl';

const DocumentsTable = ({ documents, count }) => {
  const [showTable, setShowTable] = useState(false);

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.only('xs'), { noSsr: true });

  const headerConfig = matches
    ? DOCUMENTS_TABLE_HEADER_IN_MOBILE
    : DOCUMENTS_TABLE_HEADER;

  const { open, openDialog, closeDialog } = useDialogControl();
  const [document, setDocument] = useState();

  const handleView = document => {
    setDocument(document);
    openDialog();
  };

  const getTableContent = () => {
    if (!showTable) {
      return null;
    }

    const tableBody = (
      <DocumentsTableBody
        documents={documents}
        headerConfig={headerConfig}
        handleView={handleView}
      />
    );

    return (
      <Box
        className={[
          styles.instanceListTableContainer,
          'instanceListTableContainer',
        ].join(' ')}
      >
        <Table
          stickyHeader
          className={[
            styles.instanceListTable,
            showTable ? styles.openTable : styles.closeTable,
          ].join(' ')}
        >
          <DocumentsTableHead headerConfig={headerConfig} />
          {tableBody}
        </Table>
      </Box>
    );
  };

  return (
    <Box className={[styles.tableContainer, 'tableContainer'].join(' ')}>
      <DocumentsTableToggler
        showTable={showTable}
        setShowTable={setShowTable}
        count={count}
      />
      {getTableContent()}
      {open && (
        <DocumentDialog
          open={open}
          handleClose={closeDialog}
          document={document}
        />
      )}
    </Box>
  );
};

export default DocumentsTable;
